"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitgetFutureMarginCalculator = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureMarginCalculator_1 = require("./FutureMarginCalculator");
class BitgetFutureMarginCalculator extends FutureMarginCalculator_1.SingleFutureMarginCalculator {
    //获取维持保证金率
    getMaintenanceMarginRate() {
        return new trade_utils_lib_1.SafeDecimal(0.005);
    }
    getLiquidationPrice(initMargin, openPrice, position, leverage_rate, trend) {
        // 维持保证金率
        const mmRate = this.getMaintenanceMarginRate();
        //         手续费率
        //   taker: "0.0006"
        //   maker: "0.0004"
        const feeRate = new trade_utils_lib_1.SafeDecimal("0.0006");
        if (trend === "long") {
            //liquidation_price = (init_margin - position * open_price) / position / (maintenance_margin_rate - 1 + self.get_fee_rate(False))
            return initMargin.sub(position.mul(openPrice))
                .div(position)
                .div(mmRate.sub(1).add(feeRate));
        }
        else {
            //liquidation_price = (init_margin + position * open_price) / position / (maintenance_margin_rate + 1 + self.get_fee_rate(False))
            return initMargin.add(position.mul(openPrice))
                .div(position)
                .div(mmRate.add(1).add(feeRate));
        }
    }
}
exports.BitgetFutureMarginCalculator = BitgetFutureMarginCalculator;
